const { breakpoints } = require('style/config');
const { createMedia } = require('@artsy/fresnel');

const AppMedia = createMedia({
    breakpoints: {
        xs: 0,
        sm: parseInt(breakpoints[0]),
        md: parseInt(breakpoints[1]),
        lg: parseInt(breakpoints[2])
    },
    interactions: {
        hover: '(hover: hover)',
        notHover: '(hover: none)'
    }
});

// Generate CSS to be injected into the head
const mediaStyle = AppMedia.createMediaStyle();

const { Media, MediaContextProvider, findBreakpointAtWidth } = AppMedia;

module.exports = {
    mediaStyle,
    Media,
    MediaContextProvider,
    findBreakpointAtWidth
};
